import { Spinner } from '@vwfs-bronson/bronson-react';
import { ConfigurationView } from '../views';

export function TableLoading({ view }: { view: ConfigurationView }) {
  const loadingLabel = view === 'GitHub Apps' ? 'GitHub Apps' : view.toLowerCase();

  return (
    <div className="app-loading" role="status">
      <Spinner center>Loading {loadingLabel}...</Spinner>
    </div>
  );
}
